import type {
  LabelAssignmentTarget,
  SelectedAssignmentTarget,
} from './assignedLabelsTypes';

export const mapSelectedTargetsToApi = (
  targets: SelectedAssignmentTarget[],
): LabelAssignmentTarget[] =>
  targets.map((target) =>
    target.type === 'device'
      ? { type: 'device', sn: target.sn }
      : {
          type: 'intL2',
          sn: target.sn,
          interfaceName: target.interfaceName,
        },
  );
